import { API_CONFIG } from './config';

export interface ObservabilityConfigResponse {
  prometheus_url: string;
  prometheus_lookback: string;
  prometheus_timeout?: number;
}

export interface ObservabilityConfigPayload {
  prometheus_url: string;
  prometheus_lookback: string;
}

export const getObservabilityConfig = async (
  _projectId?: string
): Promise<ObservabilityConfigResponse> => {
  const response = await fetch(`${API_CONFIG.BASE_URL}/organization-config/observability`, {
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error(`Observability config API failed: ${response.status}`);
  }

  return response.json();
};

export const saveObservabilityConfig = async (
  _projectId: string | undefined,
  payload: ObservabilityConfigPayload
): Promise<Response> =>
  fetch(`${API_CONFIG.BASE_URL}/organization-config/observability`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(payload),
  });

export const testObservabilityConnection = (
  _projectId: string | undefined,
  payload: ObservabilityConfigPayload
): Promise<Response> =>
  fetch(`${API_CONFIG.BASE_URL}/organization-config/observability/test`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
